"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _commonReact = require("@devsta/common-react");

var _PostsList = _interopRequireDefault(require("../components/PostsList"));

var _api = require("../api");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function PostsListContainer(_ref) {
  var history = _ref.history,
      loading = _ref.loading,
      loadMore = _ref.loadMore,
      getPostsListRef = _ref.getPostsListRef,
      totalResults = _ref.totalResults,
      showDeleteConfirmationModal = _ref.showDeleteConfirmationModal,
      showPublishConfirmationModal = _ref.showPublishConfirmationModal,
      showFeaturedConfirmationModal = _ref.showFeaturedConfirmationModal,
      showEditPostModal = _ref.showEditPostModal,
      refetchPosts = _ref.refetchPosts,
      posts = _ref.posts,
      orgPermissions = _ref.orgPermissions;
  return _react.default.createElement(_commonReact.RequestProvider, {
    requests: {
      bulkDeleteInspirations: (0, _api.bulkDeleteInspirationsApi)(),
      bulkPublishInspirations: (0, _api.bulkPublishInspirationsApi)()
    }
  }, function (_ref2) {
    var bulkDeleteInspirations = _ref2.bulkDeleteInspirations,
        bulkPublishInspirations = _ref2.bulkPublishInspirations;
    return _react.default.createElement(_PostsList.default, {
      bulkDeleteInspirations: bulkDeleteInspirations,
      bulkPublishInspirations: bulkPublishInspirations,
      history: history,
      loading: loading,
      loadMore: loadMore,
      getPostsListRef: getPostsListRef,
      totalResults: totalResults,
      showDeleteConfirmationModal: showDeleteConfirmationModal,
      showPublishConfirmationModal: showPublishConfirmationModal,
      showFeaturedConfirmationModal: showFeaturedConfirmationModal,
      showEditPostModal: showEditPostModal,
      refetchPosts: refetchPosts,
      posts: posts,
      orgPermissions: orgPermissions
    });
  });
}

var _default = PostsListContainer;
exports.default = _default;